import { render, staticRenderFns } from "./NodeGraphCanvas.vue?vue&type=template&id=0b63ce4c&scoped=true"
import script from "./NodeGraphCanvas.vue?vue&type=script&lang=js"
export * from "./NodeGraphCanvas.vue?vue&type=script&lang=js"
import style0 from "./NodeGraphCanvas.vue?vue&type=style&index=0&id=0b63ce4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63ce4c",
  null
  
)

export default component.exports